import { render, staticRenderFns } from "./WishlistButton.vue?vue&type=template&id=1d29f9ea"
import script from "./WishlistButton.vue?vue&type=script&lang=js"
export * from "./WishlistButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports